/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonAddressSummaryInfo = {
    ADT: BabylonAddressSummaryInfo.ADT;
    ADDR: string;
    NN: string;
    SB: string;
};

export namespace BabylonAddressSummaryInfo {

    export enum ADT {
        EOA = 'EOA',
        CA = 'CA',
    }


}

